// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MAIN CONTAINER */
.home-container {
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  overflow-x: hidden;
}

/* HEADER */
.custom-header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  transition: all 0.3s ease;
  background: transparent;
}

/* SCROLLED STATE */
.custom-header.scrolled {
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* NAV */
.custom-nav {
  max-width: 1280px; /* max-w-7xl */
  margin: 0 auto;
  padding: 0 16px;
}

@media (min-width: 640px) {
  .custom-nav {
    padding: 0 24px;
  }
}

@media (min-width: 1024px) {
  .custom-nav {
    padding: 0 32px;
  }
}
/* Group right side items */
.right-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}
/* LOGO */
.logo-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-img {
  height: 60px;
}

/* DESKTOP MENU */
.desktop-menu {
  display: none;
}

.desktop-menu a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s;
}

.desktop-menu a:hover {
  color: #fff;
}

@media (min-width: 768px) {
  .desktop-menu {
    display: flex;
    gap: 32px;
    align-items: center;
  }
}

/* ALWAYS SHOW BUTTONS */
.header-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Make buttons smaller on mobile */
@media (max-width: 767px) {
  .header-buttons {
    gap: 8px;
  }

  .btn-primary {
    padding: 8px 14px;
    font-size: 12px;
  }

  .icon-arrow {
    display: none; /* optional for clean mobile */
  }
}

/* BUTTON STYLE */
.btn-primary {
  background: #fff;
  color: #000;
  padding: 12px 24px;
  border-radius: 9999px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
}

/* ICON */
.icon-arrow {
  margin-left: 8px;
  transition: transform 0.3s;
}

.btn-primary:hover .icon-arrow {
  transform: translateX(4px);
}

/* MOBILE TOGGLE */
.mobile-toggle {
  display: block;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
}

@media (min-width: 768px) {
  .mobile-toggle {
    display: none;
  }
}

/* MOBILE MENU */
.mobile-menu {
  display: block;
  padding: 24px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-menu a {
  display: block;
  color: #9ca3af;
  text-decoration: none;
  margin-bottom: 16px;
  transition: color 0.2s;
}

.mobile-menu a:hover {
  color: #fff;
}

/* FULL WIDTH BUTTON */
.full-width {
  width: 100%;
  margin-top: 16px;
}
/* HERO SECTION */
.hero-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding-top: 80px;
}

/* BACKGROUND */
.hero-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom right, #111827, #000, #000);
}

.hero-blur-wrapper {
  position: absolute;
  inset: 0;
  opacity: 0.2;
}

.blur-circle {
  position: absolute;
  width: 384px;
  height: 384px;
  border-radius: 50%;
  filter: blur(120px);
  animation: pulse 2s infinite;
}

.blur-circle.one {
  top: 25%;
  left: 25%;
  background: white;
}

.blur-circle.two {
  bottom: 25%;
  right: 25%;
  background: #6b7280;
  animation-delay: 1s;
}

/* GRID OVERLAY */
.hero-grid {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 50px 50px;
}

/* CONTAINER */
.hero-container {
  position: relative;
  max-width: 1280px;
  margin: auto;
  padding: 80px 16px;
}

/* GRID */
.hero-grid-layout {
  display: grid;
  gap: 64px;
}

@media (min-width: 1024px) {
  .hero-grid-layout {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
}

/* LEFT */
.hero-left {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* BADGE */
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  backdrop-filter: blur(6px);
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 14px;
  color: #d1d5db;
}

.hero-badge .dot {
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

/* TITLE */
.hero-title {
  font-size: 48px;
  font-weight: bold;
  line-height: 1.2;
}

@media (min-width: 1024px) {
  .hero-title {
    font-size: 72px;
  }
}

.gradient-text {
  background: linear-gradient(to right, white, #d1d5db, #6b7280);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* DESC */
.hero-desc {
  font-size: 20px;
  color: #9ca3af;
  max-width: 500px;
}

.hero-desc strong {
  color: white;
}

/* BUTTONS */
.hero-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 640px) {
  .hero-buttons {
    flex-direction: row;
  }
}

.btn-outline {
  border: 1px solid rgba(255,255,255,0.2);
  padding: 16px 32px;
  border-radius: 999px;
  background: transparent;
  color: white;
  font-weight: 600;
}

.btn-outline:hover {
  background: rgba(255,255,255,0.05);
}

/* SOCIAL */
.hero-social {
  display: flex;
  align-items: center;
  gap: 24px;
}

.avatars {
  display: flex;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: -10px;
  background: linear-gradient(to bottom right, #4b5563, #1f2937);
  border: 2px solid black;
}

.social-title {
  font-weight: 600;
}

.social-sub {
  font-size: 14px;
  color: #9ca3af;
}

/* RIGHT DASHBOARD */
.hero-right {
  position: relative;
}

.dashboard-glow {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom right, rgba(255,255,255,0.05), transparent);
  border-radius: 24px;
  filter: blur(40px);
}

.dashboard-card {
  position: relative;
  padding: 32px;
  border-radius: 24px;
  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,0.1);
}

/* HEADER */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  font-size: 12px;
  color: #9ca3af;
  text-transform: uppercase;
}

/* DOTS */
.dots {
  display: flex;
  gap: 4px;
}

.dots .dot {
  width: 8px;
  height: 8px;
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
}

.dots .active {
  width: 24px;
  background: white;
}

/* METRICS */
.metric {
  opacity: 0.5;
  transition: all 0.5s;
}

.metric.active {
  opacity: 1;
  transform: scale(1.05);
}

.metric-top {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #d1d5db;
}

.metric-bottom {
  display: flex;
  align-items: end;
  gap: 12px;
}

.metric-value {
  font-size: 32px;
  font-weight: bold;
}

/* PROGRESS */
.progress {
  flex: 1 1;
  height: 8px;
  background: rgba(255,255,255,0.1);
  border-radius: 999px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(to right, white, #9ca3af);
  transition: width 1s;
}

/* STATS */
.dashboard-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.stat-box {
  background: rgba(0,0,0,0.3);
  padding: 16px;
  border-radius: 12px;
}

.stat-box .label {
  font-size: 12px;
  color: #9ca3af;
}

.stat-box .value {
  font-size: 20px;
  font-weight: bold;
}

.green {
  color: #4ade80;
  font-size: 12px;
}

/* ANIMATION */
@keyframes pulse {
  0%,100% { opacity: 1; }
  50% { opacity: 0.5; }
}
/* SECTION */
.stats-section {
  position: relative;
  padding: 64px 0;
  border-top: 1px solid rgba(255,255,255,0.1);
  border-bottom: 1px solid rgba(255,255,255,0.1);
  background: linear-gradient(to right, #000, #111827, #000);
}

/* CONTAINER */
.stats-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
}

@media (min-width: 640px) {
  .stats-container {
    padding: 0 24px;
  }
}

@media (min-width: 1024px) {
  .stats-container {
    padding: 0 32px;
  }
}

/* GRID */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
}

@media (min-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* ITEM */
.stat-item {
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* ICON BOX */
.stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  margin-bottom: 16px;
  transition: all 0.3s ease;
}

/* HOVER EFFECT (group-hover) */
.stat-item:hover .stat-icon {
  background: rgba(255,255,255,0.1);
  transform: scale(1.1);
}

/* VALUE */
.stat-value {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 8px;
  background: linear-gradient(to right, white, #9ca3af);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (min-width: 1024px) {
  .stat-value {
    font-size: 48px;
  }
}

/* LABEL */
.stat-label {
  font-size: 14px;
  color: #9ca3af;
}
/* SECTION */
.challenge-section {
  position: relative;
  padding: 8rem 0;
  background: #000;
}

/* CONTAINER */
.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
}

/* HEADER */
.challenge-header {
  text-align: center;
  margin-bottom: 5rem;
}

/* BADGE */
.challenge-badge {
  display: inline-block;
  font-size: 14px;
  color: #9ca3af;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 999px;
  padding: 6px 16px;
  margin-bottom: 1.5rem;
}

/* TITLE */
.challenge-title span {
  font-size: 48px;
  font-weight: bold;
  background: linear-gradient(to right, #ffffff, #6b7280);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* RESPONSIVE TITLE */
@media (min-width: 1024px) {
  .challenge-title span {
    font-size: 60px;
  }
}

/* SUBTEXT */
.challenge-subtitle {
  font-size: 20px;
  color: #9ca3af;
  max-width: 700px;
  margin: 0 auto;
}

/* GRID */
.challenge-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .challenge-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .challenge-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* CARD */
.challenge-card {
  position: relative;
  padding: 2rem;
  border-radius: 24px;
  background: linear-gradient(to bottom right, rgba(255,255,255,0.05), transparent);
  border: 1px solid rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  overflow: hidden;
}

.challenge-card:hover {
  transform: scale(1.05);
  border-color: rgba(255,255,255,0.2);
}

/* ICON */
.challenge-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(to bottom right, #6b7280, #111827);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  transition: transform 0.3s ease;
}

.challenge-card:hover .challenge-icon {
  transform: scale(1.1);
}

.challenge-icon svg {
  color: #fff;
}

/* TITLE */
.challenge-card h3 {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
}

/* DESCRIPTION */
.challenge-card p {
  color: #9ca3af;
  line-height: 1.6;
}

/* HOVER OVERLAY */
.hover-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom right, transparent, rgba(255,255,255,0.05));
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 24px;
}

.challenge-card:hover .hover-overlay {
  opacity: 1;
}
/* SECTION */
.solution-section {
  position: relative;
  /* padding: 8rem 0; */
  overflow: hidden;
  background: #000;
}

/* BACKGROUND GRADIENT OVERLAY */
.solution-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    transparent,
    rgba(17, 24, 39, 0.5),
    transparent
  );
}

/* HEADER */
.solution-header {
  text-align: center;
  margin-bottom: 5rem;
}

.solution-badge {
  display: inline-block;
  font-size: 14px;
  color: #9ca3af;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 999px;
  padding: 6px 16px;
  margin-bottom: 1.5rem;
}

.solution-title span {
  font-size: 48px;
  font-weight: bold;
  background: linear-gradient(to right, #fff, #6b7280);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (min-width: 1024px) {
  .solution-title span {
    font-size: 60px;
  }
}

.solution-subtitle {
  font-size: 20px;
  color: #9ca3af;
  max-width: 700px;
  margin: auto;
}

/* GRID */
.solution-grid {
  display: grid;
  gap: 4rem;
}

@media (min-width: 1024px) {
  .solution-grid {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
}

/* FEATURES */
.solution-features {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.feature-item {
  display: flex;
  gap: 1.5rem;
  padding: 1.5rem;
  border-radius: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.feature-item:hover {
  background: rgba(255,255,255,0.05);
}

.feature-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255,255,255,0.1);
  transition: all 0.3s ease;
}

.feature-item:hover .feature-icon {
  transform: scale(1.1);
  background: rgba(255,255,255,0.2);
}

.feature-icon svg {
  color: #fff;
}

.feature-item h3 {
  color: #fff;
  font-size: 20px;
  margin-bottom: 6px;
}

.feature-item p {
  color: #9ca3af;
}

/* RIGHT CARD */
.solution-card-wrapper {
  position: relative;
}

.solution-card-blur {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), transparent);
  border-radius: 24px;
  filter: blur(40px);
}

/* CARD */
.solution-card {
  position: relative;
  padding: 2rem;
  border-radius: 24px;
  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,0.1);
}

/* TOP */
.card-top h4 {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 1.5rem;
  letter-spacing: 1px;
}

/* PROGRESS */
.progress-item {
  margin-bottom: 1.5rem;
}

.progress-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #d1d5db;
}

.value {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
}

.progress-bar {
  height: 10px;
  background: rgba(255,255,255,0.1);
  border-radius: 999px;
  overflow: hidden;
}

.fill {
  height: 100%;
  border-radius: 999px;
}

.fill-dark {
  background: linear-gradient(to right, #4b5563, #1f2937);
}

.fill-light {
  background: linear-gradient(to right, #fff, #d1d5db);
}

/* STATS */
.card-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.stat-box {
  background: rgba(11,20,40,0.55);
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.1);
}

.stat-box span {
  font-size: 12px;
  color: #9ca3af;
}

.stat-box h3 {
  font-size: 28px;
  color: #fff;
}

/* Follows the website's own light/dark switch (data-site-theme on the Home root), not the device setting */
[data-site-theme="light"] .stat-box {
  background: rgba(194,24,91,0.07);
  border: 1px solid rgba(194,24,91,0.15);
}
[data-site-theme="light"] .stat-box span {
  color: #555f6e;
}
[data-site-theme="light"] .stat-box h3 {
  color: #1a1a2e;
}
/* SECTION */
.cta-section {
  position: relative;
  padding: 8rem 0;
  overflow: hidden;
  background: #000;
}

/* BACKGROUND GRADIENT */
.cta-bg-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom right, #111827, #000, #111827);
}

/* RADIAL GLOW */
.cta-bg-radial {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 50%, rgba(255,255,255,0.1), transparent 50%);
}

/* CONTAINER */
.cta-container {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 16px;
  text-align: center;
}

/* BADGE */
.cta-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 999px;
  padding: 8px 16px;
  margin-bottom: 2rem;
  color: #d1d5db;
  font-size: 14px;
}

.cta-badge svg {
  color: #fff;
}

/* TITLE */
.cta-title {
  font-size: 40px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.cta-title span {
  background: linear-gradient(to right, #fff, #9ca3af);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* RESPONSIVE TITLE */
@media (min-width: 1024px) {
  .cta-title {
    font-size: 60px;
  }
}

/* SUBTEXT */
.cta-subtitle {
  font-size: 20px;
  color: #9ca3af;
  margin-bottom: 3rem;
}

/* BUTTON GROUP */
.cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
}

@media (min-width: 640px) {
  .cta-buttons {
    flex-direction: row;
  }
}

/* BUTTON BASE */
.cta-btn {
  padding: 16px 32px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* PRIMARY BUTTON */
.cta-btn.primary {
  background: #fff;
  color: #000;
  border: none;
}

.cta-btn.primary:hover {
  box-shadow: 0 0 50px rgba(255,255,255,0.5);
}

/* ARROW ANIMATION */
.cta-btn .arrow {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.cta-btn.primary:hover .arrow {
  transform: translateX(5px);
}

/* SECONDARY BUTTON */
.cta-btn.secondary {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255,255,255,0.2);
}

.cta-btn.secondary:hover {
  background: rgba(255,255,255,0.1);
  border-color: rgba(255,255,255,0.4);
}
/* FOOTER */
.footer-section {
  position: relative;
  background: #000;
  border-top: 1px solid rgba(255,255,255,0.1);
  padding: 4rem 0;
}

/* CONTAINER (reuse same if already defined) */
.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
}

/* GRID */
.footer-grid {
  display: grid;
  gap: 3rem;
  margin-bottom: 3rem;
}

/* RESPONSIVE GRID */
@media (min-width: 768px) {
  .footer-grid {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }
}

/* ABOUT */
.footer-about img {
  height: 32px;
  margin-bottom: 1rem;
}

.footer-about p {
  color: #9ca3af;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

/* SOCIAL ICONS */
.footer-social {
  display: flex;
  gap: 1rem;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  cursor: pointer;
  transition: background 0.3s ease, border-color 0.3s ease;
  text-decoration: none;
}

.social-icon:hover {
  background: rgba(255,255,255,0.1);
}

/* LINKS */
.footer-links h4 {
  color: #fff;
  font-weight: 600;
  margin-bottom: 1rem;
}

.footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #9ca3af;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #fff;
}

/* BOTTOM */
.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.1);
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

/* RESPONSIVE */
@media (min-width: 768px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-between;
  }
}

/* TEXT */
.footer-bottom p {
  font-size: 14px;
  color: #9ca3af;
}

/* BOTTOM LINKS */
.footer-bottom-links {
  display: flex;
  gap: 1.5rem;
}

.footer-bottom-links a {
  font-size: 14px;
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-bottom-links a:hover {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Website/home.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA,QAAQ;AACR;EACE,iBAAiB,EAAE,cAAc;EACjC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa,EAAE,8BAA8B;EAC/C;AACF;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,gBAAgB;AAClB;AACA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR;;uEAEqE;EACrE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,uCAAuC;EACvC,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,8DAA8D;EAC9D,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;EACjF,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2FAA2F;EAC3F,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,SAAO;EACP,WAAW;EACX,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,UAAU,UAAU,EAAE;EACtB,MAAM,YAAY,EAAE;AACtB;AACA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,8CAA8C;EAC9C,0DAA0D;AAC5D;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,UAAU;AACV;EACE,eAAe;EACf,cAAc;AAChB;AACA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,iBAAiB;EACjB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;EACjB;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iFAAiF;EACjF,uCAAuC;EACvC,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8DAA8D;EAC9D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;EACjF,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;AACA,YAAY;AACZ;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;AACH;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2FAA2F;EAC3F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gFAAgF;EAChF,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2FAA2F;EAC3F,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,2GAA2G;AAC3G;EACE,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,oEAAoE;AACtE;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,sFAAsF;AACxF;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,uCAAuC;EACvC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;EACjB;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;AACA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,eAAe;EACf,wDAAwD;EACxD,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* MAIN CONTAINER */\n.home-container {\n  min-height: 100vh;\n  background-color: #000;\n  color: #fff;\n  overflow-x: hidden;\n}\n\n/* HEADER */\n.custom-header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 50;\n  transition: all 0.3s ease;\n  background: transparent;\n}\n\n/* SCROLLED STATE */\n.custom-header.scrolled {\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* NAV */\n.custom-nav {\n  max-width: 1280px; /* max-w-7xl */\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n@media (min-width: 640px) {\n  .custom-nav {\n    padding: 0 24px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .custom-nav {\n    padding: 0 32px;\n  }\n}\n/* Group right side items */\n.right-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.nav-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 80px;\n}\n/* LOGO */\n.logo-section {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.logo-img {\n  height: 60px;\n}\n\n/* DESKTOP MENU */\n.desktop-menu {\n  display: none;\n}\n\n.desktop-menu a {\n  color: #9ca3af;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.desktop-menu a:hover {\n  color: #fff;\n}\n\n@media (min-width: 768px) {\n  .desktop-menu {\n    display: flex;\n    gap: 32px;\n    align-items: center;\n  }\n}\n\n/* ALWAYS SHOW BUTTONS */\n.header-buttons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Make buttons smaller on mobile */\n@media (max-width: 767px) {\n  .header-buttons {\n    gap: 8px;\n  }\n\n  .btn-primary {\n    padding: 8px 14px;\n    font-size: 12px;\n  }\n\n  .icon-arrow {\n    display: none; /* optional for clean mobile */\n  }\n}\n\n/* BUTTON STYLE */\n.btn-primary {\n  background: #fff;\n  color: #000;\n  padding: 12px 24px;\n  border-radius: 9999px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-primary:hover {\n  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);\n}\n\n/* ICON */\n.icon-arrow {\n  margin-left: 8px;\n  transition: transform 0.3s;\n}\n\n.btn-primary:hover .icon-arrow {\n  transform: translateX(4px);\n}\n\n/* MOBILE TOGGLE */\n.mobile-toggle {\n  display: block;\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n  .mobile-toggle {\n    display: none;\n  }\n}\n\n/* MOBILE MENU */\n.mobile-menu {\n  display: block;\n  padding: 24px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mobile-menu a {\n  display: block;\n  color: #9ca3af;\n  text-decoration: none;\n  margin-bottom: 16px;\n  transition: color 0.2s;\n}\n\n.mobile-menu a:hover {\n  color: #fff;\n}\n\n/* FULL WIDTH BUTTON */\n.full-width {\n  width: 100%;\n  margin-top: 16px;\n}\n/* HERO SECTION */\n.hero-section {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding-top: 80px;\n}\n\n/* BACKGROUND */\n.hero-bg {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom right, #111827, #000, #000);\n}\n\n.hero-blur-wrapper {\n  position: absolute;\n  inset: 0;\n  opacity: 0.2;\n}\n\n.blur-circle {\n  position: absolute;\n  width: 384px;\n  height: 384px;\n  border-radius: 50%;\n  filter: blur(120px);\n  animation: pulse 2s infinite;\n}\n\n.blur-circle.one {\n  top: 25%;\n  left: 25%;\n  background: white;\n}\n\n.blur-circle.two {\n  bottom: 25%;\n  right: 25%;\n  background: #6b7280;\n  animation-delay: 1s;\n}\n\n/* GRID OVERLAY */\n.hero-grid {\n  position: absolute;\n  inset: 0;\n  background-image: \n    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);\n  background-size: 50px 50px;\n}\n\n/* CONTAINER */\n.hero-container {\n  position: relative;\n  max-width: 1280px;\n  margin: auto;\n  padding: 80px 16px;\n}\n\n/* GRID */\n.hero-grid-layout {\n  display: grid;\n  gap: 64px;\n}\n\n@media (min-width: 1024px) {\n  .hero-grid-layout {\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n  }\n}\n\n/* LEFT */\n.hero-left {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n/* BADGE */\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255,255,255,0.05);\n  border: 1px solid rgba(255,255,255,0.1);\n  backdrop-filter: blur(6px);\n  padding: 8px 16px;\n  border-radius: 999px;\n  font-size: 14px;\n  color: #d1d5db;\n}\n\n.hero-badge .dot {\n  width: 8px;\n  height: 8px;\n  background: white;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n/* TITLE */\n.hero-title {\n  font-size: 48px;\n  font-weight: bold;\n  line-height: 1.2;\n}\n\n@media (min-width: 1024px) {\n  .hero-title {\n    font-size: 72px;\n  }\n}\n\n.gradient-text {\n  background: linear-gradient(to right, white, #d1d5db, #6b7280);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* DESC */\n.hero-desc {\n  font-size: 20px;\n  color: #9ca3af;\n  max-width: 500px;\n}\n\n.hero-desc strong {\n  color: white;\n}\n\n/* BUTTONS */\n.hero-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n@media (min-width: 640px) {\n  .hero-buttons {\n    flex-direction: row;\n  }\n}\n\n.btn-outline {\n  border: 1px solid rgba(255,255,255,0.2);\n  padding: 16px 32px;\n  border-radius: 999px;\n  background: transparent;\n  color: white;\n  font-weight: 600;\n}\n\n.btn-outline:hover {\n  background: rgba(255,255,255,0.05);\n}\n\n/* SOCIAL */\n.hero-social {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.avatars {\n  display: flex;\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-left: -10px;\n  background: linear-gradient(to bottom right, #4b5563, #1f2937);\n  border: 2px solid black;\n}\n\n.social-title {\n  font-weight: 600;\n}\n\n.social-sub {\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n/* RIGHT DASHBOARD */\n.hero-right {\n  position: relative;\n}\n\n.dashboard-glow {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom right, rgba(255,255,255,0.05), transparent);\n  border-radius: 24px;\n  filter: blur(40px);\n}\n\n.dashboard-card {\n  position: relative;\n  padding: 32px;\n  border-radius: 24px;\n  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), rgba(255,255,255,0.05));\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255,255,255,0.1);\n}\n\n/* HEADER */\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  font-size: 12px;\n  color: #9ca3af;\n  text-transform: uppercase;\n}\n\n/* DOTS */\n.dots {\n  display: flex;\n  gap: 4px;\n}\n\n.dots .dot {\n  width: 8px;\n  height: 8px;\n  background: rgba(255,255,255,0.2);\n  border-radius: 50%;\n}\n\n.dots .active {\n  width: 24px;\n  background: white;\n}\n\n/* METRICS */\n.metric {\n  opacity: 0.5;\n  transition: all 0.5s;\n}\n\n.metric.active {\n  opacity: 1;\n  transform: scale(1.05);\n}\n\n.metric-top {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #d1d5db;\n}\n\n.metric-bottom {\n  display: flex;\n  align-items: end;\n  gap: 12px;\n}\n\n.metric-value {\n  font-size: 32px;\n  font-weight: bold;\n}\n\n/* PROGRESS */\n.progress {\n  flex: 1;\n  height: 8px;\n  background: rgba(255,255,255,0.1);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(to right, white, #9ca3af);\n  transition: width 1s;\n}\n\n/* STATS */\n.dashboard-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255,255,255,0.1);\n}\n\n.stat-box {\n  background: rgba(0,0,0,0.3);\n  padding: 16px;\n  border-radius: 12px;\n}\n\n.stat-box .label {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.stat-box .value {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.green {\n  color: #4ade80;\n  font-size: 12px;\n}\n\n/* ANIMATION */\n@keyframes pulse {\n  0%,100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n/* SECTION */\n.stats-section {\n  position: relative;\n  padding: 64px 0;\n  border-top: 1px solid rgba(255,255,255,0.1);\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n  background: linear-gradient(to right, #000, #111827, #000);\n}\n\n/* CONTAINER */\n.stats-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n@media (min-width: 640px) {\n  .stats-container {\n    padding: 0 24px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .stats-container {\n    padding: 0 32px;\n  }\n}\n\n/* GRID */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 32px;\n}\n\n@media (min-width: 1024px) {\n  .stats-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* ITEM */\n.stat-item {\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n/* ICON BOX */\n.stat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  background: rgba(255,255,255,0.05);\n  border: 1px solid rgba(255,255,255,0.1);\n  margin-bottom: 16px;\n  transition: all 0.3s ease;\n}\n\n/* HOVER EFFECT (group-hover) */\n.stat-item:hover .stat-icon {\n  background: rgba(255,255,255,0.1);\n  transform: scale(1.1);\n}\n\n/* VALUE */\n.stat-value {\n  font-size: 36px;\n  font-weight: bold;\n  margin-bottom: 8px;\n  background: linear-gradient(to right, white, #9ca3af);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n@media (min-width: 1024px) {\n  .stat-value {\n    font-size: 48px;\n  }\n}\n\n/* LABEL */\n.stat-label {\n  font-size: 14px;\n  color: #9ca3af;\n}\n/* SECTION */\n.challenge-section {\n  position: relative;\n  padding: 8rem 0;\n  background: #000;\n}\n\n/* CONTAINER */\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n/* HEADER */\n.challenge-header {\n  text-align: center;\n  margin-bottom: 5rem;\n}\n\n/* BADGE */\n.challenge-badge {\n  display: inline-block;\n  font-size: 14px;\n  color: #9ca3af;\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 999px;\n  padding: 6px 16px;\n  margin-bottom: 1.5rem;\n}\n\n/* TITLE */\n.challenge-title span {\n  font-size: 48px;\n  font-weight: bold;\n  background: linear-gradient(to right, #ffffff, #6b7280);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* RESPONSIVE TITLE */\n@media (min-width: 1024px) {\n  .challenge-title span {\n    font-size: 60px;\n  }\n}\n\n/* SUBTEXT */\n.challenge-subtitle {\n  font-size: 20px;\n  color: #9ca3af;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n/* GRID */\n.challenge-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n}\n\n@media (min-width: 768px) {\n  .challenge-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .challenge-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* CARD */\n.challenge-card {\n  position: relative;\n  padding: 2rem;\n  border-radius: 24px;\n  background: linear-gradient(to bottom right, rgba(255,255,255,0.05), transparent);\n  border: 1px solid rgba(255,255,255,0.1);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.challenge-card:hover {\n  transform: scale(1.05);\n  border-color: rgba(255,255,255,0.2);\n}\n\n/* ICON */\n.challenge-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  background: linear-gradient(to bottom right, #6b7280, #111827);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  transition: transform 0.3s ease;\n}\n\n.challenge-card:hover .challenge-icon {\n  transform: scale(1.1);\n}\n\n.challenge-icon svg {\n  color: #fff;\n}\n\n/* TITLE */\n.challenge-card h3 {\n  font-size: 20px;\n  font-weight: bold;\n  color: #fff;\n  margin-bottom: 10px;\n}\n\n/* DESCRIPTION */\n.challenge-card p {\n  color: #9ca3af;\n  line-height: 1.6;\n}\n\n/* HOVER OVERLAY */\n.hover-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom right, transparent, rgba(255,255,255,0.05));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 24px;\n}\n\n.challenge-card:hover .hover-overlay {\n  opacity: 1;\n}\n/* SECTION */\n.solution-section {\n  position: relative;\n  /* padding: 8rem 0; */\n  overflow: hidden;\n  background: #000;\n}\n\n/* BACKGROUND GRADIENT OVERLAY */\n.solution-bg {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to bottom,\n    transparent,\n    rgba(17, 24, 39, 0.5),\n    transparent\n  );\n}\n\n/* HEADER */\n.solution-header {\n  text-align: center;\n  margin-bottom: 5rem;\n}\n\n.solution-badge {\n  display: inline-block;\n  font-size: 14px;\n  color: #9ca3af;\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 999px;\n  padding: 6px 16px;\n  margin-bottom: 1.5rem;\n}\n\n.solution-title span {\n  font-size: 48px;\n  font-weight: bold;\n  background: linear-gradient(to right, #fff, #6b7280);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n@media (min-width: 1024px) {\n  .solution-title span {\n    font-size: 60px;\n  }\n}\n\n.solution-subtitle {\n  font-size: 20px;\n  color: #9ca3af;\n  max-width: 700px;\n  margin: auto;\n}\n\n/* GRID */\n.solution-grid {\n  display: grid;\n  gap: 4rem;\n}\n\n@media (min-width: 1024px) {\n  .solution-grid {\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n  }\n}\n\n/* FEATURES */\n.solution-features {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.feature-item {\n  display: flex;\n  gap: 1.5rem;\n  padding: 1.5rem;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.feature-item:hover {\n  background: rgba(255,255,255,0.05);\n}\n\n.feature-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), rgba(255,255,255,0.05));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255,255,255,0.1);\n  transition: all 0.3s ease;\n}\n\n.feature-item:hover .feature-icon {\n  transform: scale(1.1);\n  background: rgba(255,255,255,0.2);\n}\n\n.feature-icon svg {\n  color: #fff;\n}\n\n.feature-item h3 {\n  color: #fff;\n  font-size: 20px;\n  margin-bottom: 6px;\n}\n\n.feature-item p {\n  color: #9ca3af;\n}\n\n/* RIGHT CARD */\n.solution-card-wrapper {\n  position: relative;\n}\n\n.solution-card-blur {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), transparent);\n  border-radius: 24px;\n  filter: blur(40px);\n}\n\n/* CARD */\n.solution-card {\n  position: relative;\n  padding: 2rem;\n  border-radius: 24px;\n  background: linear-gradient(to bottom right, rgba(255,255,255,0.1), rgba(255,255,255,0.05));\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255,255,255,0.1);\n}\n\n/* TOP */\n.card-top h4 {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-bottom: 1.5rem;\n  letter-spacing: 1px;\n}\n\n/* PROGRESS */\n.progress-item {\n  margin-bottom: 1.5rem;\n}\n\n.progress-head {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  color: #d1d5db;\n}\n\n.value {\n  font-size: 22px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.progress-bar {\n  height: 10px;\n  background: rgba(255,255,255,0.1);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.fill {\n  height: 100%;\n  border-radius: 999px;\n}\n\n.fill-dark {\n  background: linear-gradient(to right, #4b5563, #1f2937);\n}\n\n.fill-light {\n  background: linear-gradient(to right, #fff, #d1d5db);\n}\n\n/* STATS */\n.card-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(255,255,255,0.1);\n}\n\n.stat-box {\n  background: rgba(11,20,40,0.55);\n  padding: 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255,255,255,0.1);\n}\n\n.stat-box span {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.stat-box h3 {\n  font-size: 28px;\n  color: #fff;\n}\n\n/* Follows the website's own light/dark switch (data-site-theme on the Home root), not the device setting */\n[data-site-theme=\"light\"] .stat-box {\n  background: rgba(194,24,91,0.07);\n  border: 1px solid rgba(194,24,91,0.15);\n}\n[data-site-theme=\"light\"] .stat-box span {\n  color: #555f6e;\n}\n[data-site-theme=\"light\"] .stat-box h3 {\n  color: #1a1a2e;\n}\n/* SECTION */\n.cta-section {\n  position: relative;\n  padding: 8rem 0;\n  overflow: hidden;\n  background: #000;\n}\n\n/* BACKGROUND GRADIENT */\n.cta-bg-gradient {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom right, #111827, #000, #111827);\n}\n\n/* RADIAL GLOW */\n.cta-bg-radial {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 30% 50%, rgba(255,255,255,0.1), transparent 50%);\n}\n\n/* CONTAINER */\n.cta-container {\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0 16px;\n  text-align: center;\n}\n\n/* BADGE */\n.cta-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255,255,255,0.05);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 999px;\n  padding: 8px 16px;\n  margin-bottom: 2rem;\n  color: #d1d5db;\n  font-size: 14px;\n}\n\n.cta-badge svg {\n  color: #fff;\n}\n\n/* TITLE */\n.cta-title {\n  font-size: 40px;\n  font-weight: bold;\n  color: #fff;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n}\n\n.cta-title span {\n  background: linear-gradient(to right, #fff, #9ca3af);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* RESPONSIVE TITLE */\n@media (min-width: 1024px) {\n  .cta-title {\n    font-size: 60px;\n  }\n}\n\n/* SUBTEXT */\n.cta-subtitle {\n  font-size: 20px;\n  color: #9ca3af;\n  margin-bottom: 3rem;\n}\n\n/* BUTTON GROUP */\n.cta-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: center;\n}\n\n@media (min-width: 640px) {\n  .cta-buttons {\n    flex-direction: row;\n  }\n}\n\n/* BUTTON BASE */\n.cta-btn {\n  padding: 16px 32px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n/* PRIMARY BUTTON */\n.cta-btn.primary {\n  background: #fff;\n  color: #000;\n  border: none;\n}\n\n.cta-btn.primary:hover {\n  box-shadow: 0 0 50px rgba(255,255,255,0.5);\n}\n\n/* ARROW ANIMATION */\n.cta-btn .arrow {\n  margin-left: 8px;\n  transition: transform 0.3s ease;\n}\n\n.cta-btn.primary:hover .arrow {\n  transform: translateX(5px);\n}\n\n/* SECONDARY BUTTON */\n.cta-btn.secondary {\n  background: transparent;\n  color: #fff;\n  border: 1px solid rgba(255,255,255,0.2);\n}\n\n.cta-btn.secondary:hover {\n  background: rgba(255,255,255,0.1);\n  border-color: rgba(255,255,255,0.4);\n}\n/* FOOTER */\n.footer-section {\n  position: relative;\n  background: #000;\n  border-top: 1px solid rgba(255,255,255,0.1);\n  padding: 4rem 0;\n}\n\n/* CONTAINER (reuse same if already defined) */\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n/* GRID */\n.footer-grid {\n  display: grid;\n  gap: 3rem;\n  margin-bottom: 3rem;\n}\n\n/* RESPONSIVE GRID */\n@media (min-width: 768px) {\n  .footer-grid {\n    grid-template-columns: 2fr 1fr 1fr 1fr;\n  }\n}\n\n/* ABOUT */\n.footer-about img {\n  height: 32px;\n  margin-bottom: 1rem;\n}\n\n.footer-about p {\n  color: #9ca3af;\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n/* SOCIAL ICONS */\n.footer-social {\n  display: flex;\n  gap: 1rem;\n}\n\n.social-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.05);\n  border: 1px solid rgba(255,255,255,0.1);\n  cursor: pointer;\n  transition: background 0.3s ease, border-color 0.3s ease;\n  text-decoration: none;\n}\n\n.social-icon:hover {\n  background: rgba(255,255,255,0.1);\n}\n\n/* LINKS */\n.footer-links h4 {\n  color: #fff;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-links li {\n  margin-bottom: 10px;\n}\n\n.footer-links a {\n  color: #9ca3af;\n  font-size: 14px;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-links a:hover {\n  color: #fff;\n}\n\n/* BOTTOM */\n.footer-bottom {\n  border-top: 1px solid rgba(255,255,255,0.1);\n  padding-top: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n}\n\n/* RESPONSIVE */\n@media (min-width: 768px) {\n  .footer-bottom {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n\n/* TEXT */\n.footer-bottom p {\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n/* BOTTOM LINKS */\n.footer-bottom-links {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.footer-bottom-links a {\n  font-size: 14px;\n  color: #9ca3af;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-bottom-links a:hover {\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
